import { format, parseISO } from 'date-fns';
import { FieldPath } from 'react-hook-form';

import { parseDateRange } from 'components/shared/DatePicker/functions';
import { AdapterType } from 'utils/types';

import { getFormattedDatesRange } from '../functions';
import { FieldValues, TInputDatePickerProps } from '../type';

export const DefaultValuePlank = function <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ mode, field: { value } }: AdapterType<TFieldValues, TName> & TInputDatePickerProps) {
  if (!value) return null;

  if (mode === 'range') {
    return <span>{getFormattedDatesRange(parseDateRange(value))}</span>;
  }

  return <span>{`${format(parseISO(value), 'MMMM d, yyyy')}`}</span>;
};
